export function replaceWithNumbersOnly(str) {
  return str.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
}

export function isValidDomain(str) {
  return str.match(/^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/);
}
